import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { LOGIN } from '@app/@core/constants/routes.constants';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class FooterComponent implements OnInit {
  @Input() isThirdparty: boolean;
  private _paths: string[] = [LOGIN, '/password'];
  isCentered: boolean;
  langActive: string = '';
  footerLinks = [
    {
      // Aviso legal
      url:
        'https://www.sabadellconsumer.com/cs/Satellite/BSFincom/Aviso-legal/GBS_Generico_FA/1191431012406/1191430746508/es/',
      text: 'footer.toolbar.aviso',
      id: 'avisoLinkFooter',
    },
    {
      // Seguridad
      url: 'https://www.sabadellconsumer.com/doc/2001609_SeguridadCompras_BSConsumer_Noviembre_2020.pdf',
      text: 'footer.toolbar.seguridad',
      id: 'seguridadLinkFooter',
    },
    {
      // Información a clientes
      url:
        'https://www.sabadellconsumer.com/cs/Satellite/BSFincom/Informacion-a-clientes/GBS_Generico_FA/1191347638032/1191430746508/es/',
      text: 'footer.toolbar.informacion',
      id: 'informacionLinkFooter',
    },
    {
      // Condiciones de Uso
      url: 'https://www.sabadellconsumeronline.com/SabadellConsumer/html/condiciones.htm',
      text: 'footer.toolbar.condiciones',
      id: 'condicionesLinkFooter',
    },
    {
      // configurar de cookies
      url: 'OneTrust.ToggleInfoDisplay()',
      text: 'footer.cookiesSettings',
      id: 'cookiesSettings',
    },
    {
      // Política de cookies
      url: '/globalcredit/cookies-policy',
      text: 'footer.toolbar.politica',
      id: 'cookiesPolicy',
    },
    {
      // Accesibilidad
      url: '/globalcredit/accesibility',
      text: 'footer.toolbar.accesibility',
      id: 'accesibility',
    },
  ];

  constructor(private router: Router, private translateService: TranslateService) {
    this.langActive = this.translateService.currentLang;
  }

  ngOnInit(): void {
    this.translateService.onLangChange.pipe().subscribe((event) => {
      event.lang === 'es-ES' ? (this.langActive = 'es-ES') : (this.langActive = 'es-CAT');
    });
  }

  openPage(url: string) {
    window.open(url);
  }

  validatePath(url: string) {
    //let regexIsLogin = new RegExp(this._paths[0]);
    //let regexIsPassword = new RegExp(this._paths[1]);
    //regexIsLogin.test(url) || regexIsPassword.test(url) ? (this.isCentered = true) : (this.isCentered = false);
  }
}
